import React from 'react';
import {
  useCloseMergeSuggestionAndContinue,
  useSetMergeSuggestionQueue,
} from 'services/mergeSuggestions';
import {selectMergeSuggestionQueue} from 'services/mergeSuggestions/mergeSuggestionQueueSlice';
import {useAppSelector} from 'store/hooks';
import {FlexBox, NextButton} from 'components';
import {ActionButtonV2} from 'components/button/ActionButtonV2';
import {ConfirmButtonV2} from '../../../components/button/ConfirmButtonV2';
import {useCollapseContext} from '../context/CollapseContext';
import {useCompareEntitiesContext} from '../context/CompareEntitiesContext';

export const CompareEntitiesActions = () => {
  const {onSave, target, source, showFullSource, toggleShowFullSource} =
    useCompareEntitiesContext();
  const {
    enabled: allowCollapseMainEntity,
    isCollapsed,
    toggleCollapse,
  } = useCollapseContext();
  const queue = useAppSelector(selectMergeSuggestionQueue);
  const setQueue = useSetMergeSuggestionQueue();

  const {closeSuggestionAndContinue, currentMergeSuggestion} =
    useCloseMergeSuggestionAndContinue(
      target?.data?.id as string | undefined,
      source?.data?.id as string | undefined,
    );

  return (
    <FlexBox horizontal spaceBetween width={'100%'}>
      <FlexBox horizontal left width={'100%'} gap={2}>
        {allowCollapseMainEntity ? (
          <ActionButtonV2
            size={'medium'}
            color={'secondary'}
            title={`${isCollapsed ? 'Skjul' : 'Vis'} detaljer`}
            onClick={() => {
              toggleCollapse();
            }}
          />
        ) : null}

        {/* Only show the toggle source button if the main entity details are shown, to avoid confusion */}
        {isCollapsed ? (
          <ActionButtonV2
            size={'medium'}
            color={'secondary'}
            title={`${showFullSource ? 'Vis kun endringer' : 'Vis hele kilden'}`}
            onClick={() => {
              toggleShowFullSource();
            }}
          />
        ) : null}
      </FlexBox>
      <FlexBox horizontal right width={'100%'} gap={2}>
        <NextButton items={queue} setter={setQueue} />

        <ActionButtonV2
          title={'Avslå forslag'}
          color={'error'}
          onClick={() => {
            closeSuggestionAndContinue();
          }}
          /*
            If someone manually adds IDs to the url, then there might not exist a
            suggestion. But we still allow merging on these IDs, but disables
            this button.
          */
          disabled={!currentMergeSuggestion}
        />
        <ConfirmButtonV2
          icon={'Check'}
          color={'success'}
          title={'Slå sammen'}
          onClick={() => {
            onSave()
              .then(() => {
                closeSuggestionAndContinue();
              })
              .catch(() => {
                // Do nothing.
              });
          }}
        />
      </FlexBox>
    </FlexBox>
  );
};
